import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { State } from 'vuex-class';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppCheckbox from '@/components/AppCheckbox.vue';
import AppDatePicker from '@/components/AppDatePicker.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppTextField from '@/components/AppTextField.vue';
import AppSelector from '@/components/AppSelector.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import AppSimpleSelector from '@/components/AppSimpleSelector.vue';
import AppSimpleTextField from '@/components/AppSimpleTextField.vue';
import AppSimpleDatePicker from '@/components/AppSimpleDatePicker.vue';
import AppSimpleSearchSelector from '@/components/AppSimpleSearchSelector.vue';
import AppRadio from '@/components/AppRadio.vue';
import AppLightModal from '@/components/AppLightModal.vue';
import { showErrors, showNotification } from '@/utils/snack';
import { SnackType } from '@/interfaces/snack';
import { utcDateTimeToLocal, formatWeixinDate } from '@/utils/dateTime';
import ListPage from '@/mixins/list-page';
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue';
import { findOrders, findAllPeriod } from './gql';
import { OrdersOrderBy, OrderStatus } from '@/interfaces/order';
import { statusCodes, statusOptions, OrderStatusText, refundOptions, refundKey, RefundWayText } from '@/helpers/order';
import { createRefund, cancelRefund } from '../RefundList/gql';
import AppTextarea from '@/components/AppTextarea.vue';
import AuthFilter from '@/mixins/auth-filter';
import { findDealers } from '@/views/DealerList/gql';
import { auditStatusText } from '@/helpers/audit';
import { formatCurrency } from '@/utils/currency';
import { dispatchUpdateIfNewOrders } from '../../store/dispatches';

var OrderList = /*#__PURE__*/function (_mixins) {
  _inherits(OrderList, _mixins);

  var _super = _createSuper(OrderList);

  function OrderList() {
    var _this;

    _classCallCheck(this, OrderList);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '订单管理'
    }, {
      text: '申请退款订单'
    }];
    _this.options = {
      sortBy: ['createdAt'],
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    };
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    _this.formatWeixinDate = formatWeixinDate;
    _this.formatCurrency = formatCurrency;
    _this.OrderStatusText = OrderStatusText;
    _this.filter = {
      area: null,
      orderNumber: null,
      transactionNumber: null,
      period_EQ: -1,
      dealerId: {
        id: null,
        label: ''
      },
      orderTimeStart: null,
      orderTimeEnd: null,
      phone: null,
      studentName: null,
      schoolName: null,
      statusIndex: -1
    };
    _this.totalNum = 0;
    _this.loading = false;
    _this.headers = [{
      text: '操作',
      value: 'operation',
      sortable: false,
      width: 100
    }, {
      text: '退款方式',
      value: 'refund.refundWay',
      sortable: false,
      width: 140
    }, {
      text: '审核状态',
      value: 'refund.auditStatus',
      sortable: false,
      width: 120
    }, {
      text: '订单状态',
      value: 'status',
      width: 150
    }, {
      text: '征订周期',
      value: 'period',
      sortable: false,
      width: 130
    }, {
      text: '经销商',
      value: 'dealer.realname',
      sortable: false,
      width: 120
    }, {
      text: '订单编号',
      value: 'orderNumber',
      width: 200
    }, {
      text: '订单流水编号',
      value: 'transactionNumber',
      width: 200
    }, {
      text: '商品/单价',
      value: 'items'
    }, {
      text: '买家',
      value: 'address',
      width: 140
    }, {
      text: '支付',
      value: 'payWay',
      sortable: false,
      width: 90
    }, {
      text: '价格',
      value: 'totalPrice',
      width: 80
    }, {
      text: '下单时间',
      value: 'createdAt',
      width: 120
    }, {
      text: '付款时间',
      value: 'timeEnd',
      width: 120
    }, {
      text: '备注',
      value: 'buyerMessage',
      sortable: false,
      width: 80
    }];
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.statusCodes = statusCodes();
    _this.statusOptions = statusOptions();
    _this.refundDialog = {
      show: false,
      title: '创建退款单',
      disable: false,
      confirmText: '创建退款单'
    };
    _this.refundInput = {};
    _this.refundTypeDialog = {
      show: false,
      title: '选择退款方式'
    };
    _this.refundOptions = refundOptions();
    _this.refundKey = refundKey();
    _this.RefundWayText = RefundWayText;
    _this.AuditStatusText = auditStatusText;
    _this.refundWithdrawDialog = {
      show: false,
      text: '确认撤销退款?'
    };
    _this.periodOptions = [];
    _this.dealerOptions = [];
    _this.OrderStatus = OrderStatus;
    _this.actionsHeight = 51;
    _this.orders = [];
    _this.orderInfo = null;
    _this.confirmForm = false;
    return _this;
  }

  _createClass(OrderList, [{
    key: "usingStatus",
    value: function usingStatus(status) {
      return {
        'u-tag-blue': status === this.OrderStatus.TO_BE_PAID,
        'u-tag-red': status === this.OrderStatus.ERROR,
        'u-tag-orange': status === this.OrderStatus.REFUNDING,
        'u-tag-green': status === this.OrderStatus.SUCCESS,
        'u-tag-dark': status === this.OrderStatus.CLOSED,
        'u-tag-grey': status === this.OrderStatus.REFUND,
        'u-tag-yellow': status === this.OrderStatus.PAID
      };
    }
  }, {
    key: "onOptionsChanged",
    value: function onOptionsChanged() {
      this.getOrders();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.onResize();
      this.restorePage(this.cache);
      this.getOrders();
      this.getPeriodOptions();
      this.getDealerOptions();
    }
  }, {
    key: "getOrders",
    value: function () {
      var _getOrders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$options, sortBy, page, itemsPerPage, sortDesc, _this$filter, orderNumber, statusIndex, period_EQ, transactionNumber, phone, dealerId, by, asc, order, paging, where, result;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$options = this.options, sortBy = _this$options.sortBy, page = _this$options.page, itemsPerPage = _this$options.itemsPerPage, sortDesc = _this$options.sortDesc;
                _this$filter = this.filter, orderNumber = _this$filter.orderNumber, statusIndex = _this$filter.statusIndex, period_EQ = _this$filter.period_EQ, transactionNumber = _this$filter.transactionNumber, phone = _this$filter.phone, dealerId = _this$filter.dealerId;
                by = OrdersOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                paging = {
                  skip: itemsPerPage * (page - 1),
                  take: itemsPerPage * page
                };
                where = {
                  orderNumber: orderNumber || null,
                  status_EQ: this.statusCodes[statusIndex] || null,
                  period_EQ: this.periodOptions[period_EQ] || null,
                  transactionNumber: transactionNumber,
                  phone: phone,
                  dealerId: dealerId ? dealerId.id : null
                };
                _context.next = 10;
                return this.queryOrdersRequest(order, paging, where);

              case 10:
                result = _context.sent;

                if (result) {
                  this.orders = result.orders;
                  this.totalNum = result.paging.totalCount;
                }

                this.loading = false;
                this.storePage();
                dispatchUpdateIfNewOrders({
                  refundApplication: false
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getOrders() {
        return _getOrders.apply(this, arguments);
      }

      return getOrders;
    }()
  }, {
    key: "getPeriodOptions",
    value: function () {
      var _getPeriodOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$apollo.query({
                  query: findAllPeriod
                });

              case 3:
                result = _context2.sent;

                if (result) {
                  this.periodOptions = result.data.findAllUsedPeriodSettings;
                }

                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getPeriodOptions() {
        return _getPeriodOptions.apply(this, arguments);
      }

      return getPeriodOptions;
    }()
  }, {
    key: "getDealerOptions",
    value: function () {
      var _getDealerOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(query) {
        var where, take, result, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                where = query && query.model ? {
                  realname: query.model
                } : null;
                take = query && query.take ? query.take : 20;
                _context3.prev = 2;
                _context3.next = 5;
                return this.$apollo.query({
                  query: findDealers,
                  variables: {
                    order: null,
                    paging: {
                      skip: 0,
                      take: take
                    },
                    where: where
                  }
                });

              case 5:
                result = _context3.sent;

                if (result.data.findDealers) {
                  this.dealerOptions = result.data.findDealers.dealers.map(function (option) {
                    return {
                      id: option.id,
                      label: option.realname
                    };
                  });
                }

                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](2);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 9]]);
      }));

      function getDealerOptions(_x) {
        return _getDealerOptions.apply(this, arguments);
      }

      return getDealerOptions;
    }()
  }, {
    key: "queryOrdersRequest",
    value: function () {
      var _queryOrdersRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(order, paging, where) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.$apollo.query({
                  query: findOrders,
                  variables: {
                    order: order,
                    paging: paging,
                    where: where
                  }
                });

              case 3:
                result = _context4.sent;
                return _context4.abrupt("return", result.data.findRefundRequiringOrders);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                typedError = _context4.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function queryOrdersRequest(_x2, _x3, _x4) {
        return _queryOrdersRequest.apply(this, arguments);
      }

      return queryOrdersRequest;
    }()
  }, {
    key: "routeToDetail",
    value: function routeToDetail(item) {
      this.$router.push({
        name: 'OrderDetail',
        params: {
          id: item.id + '',
          orderNumber: item.orderNumber
        }
      });
    }
  }, {
    key: "filterQuerySubmit",
    value: function filterQuerySubmit() {
      this.getOrders();
    }
  }, {
    key: "refreshList",
    value: function refreshList() {
      this.filter = {
        area: null,
        orderNumber: null,
        transactionNumber: null,
        orderTimeStart: null,
        orderTimeEnd: null,
        phone: null,
        studentName: null,
        schoolName: null,
        statusIndex: -1,
        period_EQ: -1,
        dealerId: {
          id: null,
          label: ''
        }
      };
      this.getOrders();
    }
  }, {
    key: "exportHandler",
    value: function exportHandler() {}
  }, {
    key: "refundHandler",
    value: function refundHandler(item) {
      this.orderInfo = JSON.parse(JSON.stringify(item));
      this.orderInfo.totalPrice = Number(this.formatCurrency(this.orderInfo.totalPrice));
      this.refundInput = {};
      this.refundTypeDialog.show = true;
    }
  }, {
    key: "refundTypeConfirm",
    value: function refundTypeConfirm() {
      if (typeof this.refundInput.refundType !== 'undefined') {
        this.refundDialog.show = true;
        this.refundTypeDialog.show = false;
      } else {
        showNotification({
          msg: '请选择退款类型!',
          type: SnackType.Info
        });
      }
    }
  }, {
    key: "refundTypeCancel",
    value: function refundTypeCancel() {
      this.refundTypeDialog.show = false;
    }
  }, {
    key: "refundWithdrawHandler",
    value: function refundWithdrawHandler(item) {
      this.orderInfo = item;
      this.refundWithdrawDialog.show = true;
    }
  }, {
    key: "refundWithdrawCancel",
    value: function refundWithdrawCancel() {
      this.refundWithdrawDialog.show = false;
    }
  }, {
    key: "refundWithdrawConfirm",
    value: function () {
      var _refundWithdrawConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this$orderInfo, result, typedError;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.$apollo.mutate({
                  mutation: cancelRefund,
                  variables: {
                    orderId: (_this$orderInfo = this.orderInfo) === null || _this$orderInfo === void 0 ? void 0 : _this$orderInfo.id
                  }
                });

              case 3:
                result = _context5.sent;

                if (result) {
                  this.refundWithdrawDialog.show = false;
                  showNotification({
                    msg: '撤销退款成功',
                    type: SnackType.Success
                  });
                  this.getOrders();
                }

                _context5.next = 13;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                this.confirmForm = false;
                this.refundDialog.show = false;
                typedError = _context5.t0;
                showErrors(typedError.graphQLErrors);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function refundWithdrawConfirm() {
        return _refundWithdrawConfirm.apply(this, arguments);
      }

      return refundWithdrawConfirm;
    }()
  }, {
    key: "refundFormConfirm",
    value: function () {
      var _refundFormConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this$refundInput, description, refundType, _this$orderInfo2, result, typedError;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.confirmForm = true;
                _this$refundInput = this.refundInput, description = _this$refundInput.description, refundType = _this$refundInput.refundType;
                _context6.prev = 2;
                _context6.next = 5;
                return this.$apollo.mutate({
                  mutation: createRefund,
                  variables: {
                    orderId: (_this$orderInfo2 = this.orderInfo) === null || _this$orderInfo2 === void 0 ? void 0 : _this$orderInfo2.id,
                    description: description,
                    refundWay: this.refundKey[refundType]
                  }
                });

              case 5:
                result = _context6.sent;

                if (result) {
                  this.confirmForm = false;
                  this.refundDialog.show = false;
                  showNotification({
                    msg: '创建退款单成功',
                    type: SnackType.Success
                  });
                  this.refundInput = {};
                  this.getOrders();
                }

                _context6.next = 15;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](2);
                this.confirmForm = false;
                this.refundDialog.show = false;
                typedError = _context6.t0;
                showErrors(typedError.graphQLErrors);

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 9]]);
      }));

      function refundFormConfirm() {
        return _refundFormConfirm.apply(this, arguments);
      }

      return refundFormConfirm;
    }()
  }, {
    key: "refundFormCancel",
    value: function refundFormCancel() {
      this.refundInput = {};
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var actionDom = this.$refs.actions;
      this.actionsHeight = actionDom.clientHeight;
    }
  }]);

  return OrderList;
}(mixins(ListPage, AuthFilter));

__decorate([State(function (state) {
  return state.page.OrderList;
})], OrderList.prototype, "cache", void 0);

__decorate([Watch('options', {
  deep: true
})], OrderList.prototype, "onOptionsChanged", null);

OrderList = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppCheckbox: AppCheckbox,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleTextField: AppSimpleTextField,
    AppSimpleSelector: AppSimpleSelector,
    AppDatePicker: AppDatePicker,
    AppSearchBtn: AppSearchBtn,
    AppSelector: AppSelector,
    AppTextField: AppTextField,
    AppSimpleDatePicker: AppSimpleDatePicker,
    AppLightModal: AppLightModal,
    AppSimpleDistrictSelector: AppSimpleDistrictSelector,
    AppTextarea: AppTextarea,
    AppRadio: AppRadio,
    AppSimpleSearchSelector: AppSimpleSearchSelector
  }
})], OrderList);
export default OrderList;